import {icon} from '#core/utils/style-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import {PRICE_BOOST_ICON_SRC} from '#core/application/modules/tiles/price-boost-label/index.js';
import {generateStreamingIndicator} from '#core/application/modules/tiles/streaming-indicator/index.js';

import EVENT_TIMING_STATUS from './event-timing-status.palette-schema.yaml';

registerTileSchema(EVENT_TIMING_STATUS);

export function generateEventTimingStatus(TILE) {
    return {
        dateTimeContainer: {
            separator: {
                style: {
                    color: TILE.EVENT_TIMING_SEPARATOR_COLOR,
                },
            },
        },
        liveText: {
            style: {
                whiteSpace: 'nowrap',
                ...TILE.EVENT_TIMING_LIVE_TEXT,
            },
        },
        upcomingText: {
            style: {
                whiteSpace: 'nowrap',
                ...TILE.EVENT_TIMING_UPCOMING_TEXT,
            },
        },
        eventSignpostingIcons: {
            baseSignpostIcon: icon(TILE.EVENT_TIMING_SIGNPOSTING_ICON_COLOR),
            priceBoostIcon: {
                src: PRICE_BOOST_ICON_SRC,
            },
            neutralVenueIcon: icon(TILE.EVENT_TIMING_NEUTRAL_VENUE_INDICATOR.NVI_ICON_COLOR),
            streamingIcon: generateStreamingIndicator(TILE.EVENT_TIMING_STREAMING_INDICATOR),
        },
    };
}
